module.exports = __webpack_public_path__ + "img/fuel.8ab8b9fd.png";